// Import Semantic UI
import 'semantic-ui-less/semantic.less';



// WEBPACK FOOTER //
// ./src/semantic.js